import type { TypedDocumentNode } from '@apollo/client';
import { gql } from '@apollo/client';

import { COMMON_GAME_SET } from '#src/set/index.ts';

import type { getSpecialSetCardPackGroupsThatAreNotFeatured_cardPackGroup } from './__generated__/cardSets.graphql.ts';
import { withFragments } from './gql/index.ts';

export const ACTIVE_SET_EDITION = [
  ...COMMON_GAME_SET.cardSet.activeEditionSlugs,
];
const STELLAR_EDITION = [
  'stellar_standard_base',
  'stellar_shiny_base',
  'stellar_shiny_jersey_number',
  'stellar_shiny_meteor_striker',
  'stellar_holo_base',
  'stellar_holo_action_shot',
  'stellar_full_art_base',
  'stellar_full_art_signed',
];

export const SET_EDITION = [...ACTIVE_SET_EDITION, ...STELLAR_EDITION];

export const SUPPORTED_CARD_SETS = [
  ...COMMON_GAME_SET.cardSet.supportedSlugs,
] as const;
export type SupportedCardSet = (typeof SUPPORTED_CARD_SETS)[number];

export const isSupportedCardSet = (
  setSlug: Nullable<string>
): setSlug is SupportedCardSet => {
  if (!setSlug) {
    return false;
  }
  return SUPPORTED_CARD_SETS.some(supportedSet => supportedSet === setSlug);
};

export const isSpecialCardSet = (setSlug: Nullable<string>) => {
  return !!setSlug && setSlug !== COMMON_GAME_SET.cardSet.baseSlug;
};

export const getDisplayCardSetName = (setSlug: Nullable<string>) => {
  if (setSlug === COMMON_GAME_SET.cardSet.activeSlug) {
    return COMMON_GAME_SET.cardSet.displayName;
  }
  return setSlug;
};

export const getSpecialSetCardPackGroupsThatAreNotFeatured = withFragments(
  <T extends getSpecialSetCardPackGroupsThatAreNotFeatured_cardPackGroup>(
    cardPackGroups: NonNullable<T[]>
  ): T[] => {
    return cardPackGroups.filter(
      ({ featured, cardSet }) => isSpecialCardSet(cardSet?.slug) && !featured
    );
  },
  {
    cardPackGroup: gql`
      fragment getSpecialSetCardPackGroupsThatAreNotFeatured_cardPackGroup on CardPackGroup {
        id
        featured
        cardSet {
          slug
        }
      }
    ` as TypedDocumentNode<getSpecialSetCardPackGroupsThatAreNotFeatured_cardPackGroup>,
  }
);
